import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { getOrgTermsContent } from '../../../content/utils.js';
import DatePickerAdapter from '../../DatePickerAdapter.jsx';
import FieldGroup from '../../FieldGroup.jsx';

function ActivityForm() {
  return (
    <React.Fragment>
      <Field
        id="activityFormTitle"
        name="title"
        label="Title"
        placeholder={getOrgTermsContent('activityLabels.title')}
        type="text"
        component={FieldGroup}
      />
      <Row>
        <Col sm={6}>
          <Field
            id="activityFormStartDate"
            name="startDate"
            label="Start Date"
            placeholderText="Select a date"
            component={DatePickerAdapter}
            allowNull
          />
        </Col>
        <Col sm={6}>
          <Field
            id="activityFormEndDate"
            name="endDate"
            label="End Date"
            placeholderText="Select a date"
            component={DatePickerAdapter}
            allowNull
          />
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default ActivityForm;
